<template>
    <div class="smagtron-tv__container">

        <div class="skew-link">
            <p class="h4">{{ mainHeadline }}</p>
        </div>

        <div class="wrapper">
            <div class="swiper-outer-container">
                <div class="swiper-container" ref="smagtronTvSwiper">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="entry in listEntries">
                            <div class="row">
                                <div class="col-md-6">
                                    <iframe frameborder="0" scrolling="no" marginheight="0" marginwidth="0" width="100%" height="275" type="text/html" class="smagtron-tv__iframe"
                                                :src="'https://www.youtube.com/embed/'+ entry.ytLink +'?autoplay=0&fs=0&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0'">
                                    </iframe>
                                </div>
                                <div class="col-md-6">
                                    <div class="content">
                                        <span class="h2 smagtron-tv__swiper-headline">{{ entry.headline }}</span>
                                        <p class="white">{{ entry.text }}</p>
                                        <a v-if="typeof entry.btntext === 'undefined'" :href="entry.url" class="btn">{{ entry.name }}</a>
                                        <a v-else :href="entry.url" class="btn">{{ entry.btntext }}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="smagtron-tv__pagination-wrapper">
                    <div class="swiper-pagination smagtron-tv__pagination-wrapper" ref="pagination"></div>
                </div>

                <div class="swiper-button-prev" ref="prev">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18">
                        <path fill="#FFF" d="M8.45833178,0.292893219 L9.87254534,1.70710678 L2.414,9.165 L9.87254534,16.6237703 L8.45833178,18.0379839 L0.292893219,9.87254534 C-0.0675907428,9.51206138 -0.0953202783,8.94483033 0.209704612,8.55253912 L0.292893219,8.45833178 L8.45833178,0.292893219 Z"/>
                    </svg>
                </div>

                <div class="swiper-button-next" ref="next">
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18">
                        <path fill="#FFF" d="M8.45833178,0.292893219 L9.87254534,1.70710678 L2.414,9.165 L9.87254534,16.6237703 L8.45833178,18.0379839 L0.292893219,9.87254534 C-0.0675907428,9.51206138 -0.0953202783,8.94483033 0.209704612,8.55253912 L0.292893219,8.45833178 L8.45833178,0.292893219 Z"/>
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swiper from "swiper";

    export default {
        data(){
          return{
              swiperInstance: null
          }
        },
        props: {
            listEntries: Array,
            mainHeadline: String,
            btntext: String,
        },

        mounted(){
          this.initSwiper()
        },

        methods: {
            initSwiper(){
                this.$nextTick(()=> {
                    let swiperRef = this.$refs.smagtronTvSwiper;
                    this.swiperInstance = new Swiper(swiperRef, {
                        navigation: {
                            nextEl: this.$refs.next,
                            prevEl: this.$refs.prev,
                        },
                        pagination: {
                            el: this.$refs.pagination,
                            type: 'bullets',
                        },
                        slidesPerView: 1,
                        spaceBetween: 10,
                        loop: false,
                    });
                });
            },
        }

    }
</script>
